export const promptsKeys = {
    all: () => ['prompts'],
    allDefault: () => [...promptsKeys.all(), 'default']
};
//# sourceMappingURL=prompts.keys.js.map